<template>
  <v-container>
    <v-row class="justify-start">
      <v-col
        v-for="attachment in computedAttachments"
        :key="attachment.id"
        class="col-sm-12 col-md-6 col-lg-3 col-xl-2"
      >
        <attachment-tile
          :attachment="attachment"
          :checked="isChecked(attachment)"
          @checkedAttachment="checkAttachment"
        ></attachment-tile>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { getIconColorByFileType, getIconByFileType } from '@/assets/js/utility';

import AttachmentTile from '@/components/AttachmentTile';

export default {
  name: 'AttachmentTileGrid',
  components: { AttachmentTile },
  props: {
    attachments: {
      type: Array,
      required: true,
    },
    assigned: {
      type: Array,
      required: false,
    },
  },
  methods: {
    isChecked(attachment) {
      if (this.assigned !== null) {
        return !!this.assigned.find(a => a.id === attachment.id);
      }
      return false;
    },
    checkAttachment(attachment) {
      if (this.isChecked(attachment)) {
        this.computedAssigned = this.assigned.filter(a => a.id !== attachment.id);
      } else {
        this.$set(this.computedAssigned, this.computedAssigned.length, attachment);
      }
    },
  },
  data: () => ({}),
  computed: {
    computedAttachments() {
      return this.attachments.map(at => {
        return {
          ...at,
          icon: getIconByFileType(at.filename),
          iconColor: getIconColorByFileType(at.filename),
        };
      });
    },
    computedAssigned: {
      get() {
        return this.assigned;
      },
      set(nV) {
        this.$emit('input', nV);
      },
    },
  },
};
</script>

<style scoped></style>
